module.exports = __webpack_public_path__ + "img/8C.f9b9814a.png";